export const IntroSecDetails = {
  heading1: "Helping You Find Hope, Strength, and Clarity.",
  typeWritterHeading: "Renewed Clarity Counseling",
  heading2: "based in Grandville, Michigan.",
  btnText: "Download CV",
};
export const AboutSecDetails = {
  image: {
    img: "images/about-me.jpg",
  },
  information: {
    title1: "About Me",
    name: "Melissa Vander Kooi",
    desc1:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec nulla venenatis, sollicitudin ipsum rhoncus, vehicula elit. Ut lectus neque, pharetra nec sagittis ac, rhoncus at augue.",
    desc2:
      "Phasellus ut ultrices nisi. Mauris pretium est vitae risus elementum egestas. Aliquam ac tincidunt orci. Praesent ut augue cursus, interdum est eget, ullamcorper massa. Curabitur porta risus quis varius pellentesque. Morbi efficitur, felis et pellentesque aliquam, lacus lectus vestibulum dui, in pellentesque tellus lectus sed purus.",
  },
  moreAbout: [
    {
      num: 999,
      title: "Years Experience",
    },
    {
      num: 999,
      title: "Happy Clients",
    },
  ],
};

export const ServicesDetails = {
  heading: {
    title: "Services",
    text: "Some kind of tagline here",
  },
  details: [
    {
      name: "Lorem Ipsum",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
      icon: "fas fa-star",
    },
    {
      name: "Lorem Ipsum",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
      icon: "fas fa-handshake",
    },
    {
      name: "Lorem Ipsum",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
      icon: "fas fa-hospital",
    },
  ],
};

export const MyWorking_Skills = {
  heading: {
    title: "Why I'm Different?",
    text: "Some kind of tagline here",
  },
  video: {
    vdo: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  working: [
    {
      name: "Lorem Ipsum",
      icon: "fas fa-fingerprint",
      desc: "Lorem Ipsum has been the industry’s standard dummy text.",
    },
    {
      name: "Lorem Ipsum",
      icon: "fas fa-cog",
      desc: "Lorem Ipsum has been the industry’s standard dummy text.",
    },
    {
      name: "Lorem Ipsum",
      icon: "fas fa-layer-group",
      desc: "Lorem Ipsum has been the industry’s standard dummy text.",
    }
  ],
  skills: [
    {
      skill: "Skill 1 here",
      percent: 95,
    },
    {
      skill: "Skill 2 here",
      percent: 65,
    },
    {
      skill: "Skill 3 here",
      percent: 80,
    },
    {
      skill: "Skill 4 here",
      percent: 75,
    },
  ],
};

export const CallToActionDetails = {
  heading: "Start a project with Me today!",
  subHeading: "I am Available for Freelancer.",
  btnText: "Hire Me",
};

export const WorkProcessDetails = {
  heading: {
    title: "Work Process",
    text: "Simple work process of build your design. Delivering work within time and budget which meets client’s requirements is our moto.",
  },
  WDetails: [
    {
      sno: 1,
      name: "Planning & Consulting",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 2,
      name: "Content",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 3,
      name: "Conception",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 4,
      name: "Design & Development",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 5,
      name: "Final discussion",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 6,
      name: "Delivery & Launch",
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
  ],
};

export const OurClientsDetails = {
  heading: {
    title: "My Clients",
    text: "Real Stories of Growth, Healing, and Hope.",
  },
  clients: [
    {
      name: "Jay Shah",
      img: "images/testimonial/client-sm-1.jpg",
      exp: "Lorem ipsum",
      summary:
        " “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae suscipit tellus mauris a diam maecenas sed enim ut sem viverra.“",
    },
    {
      name: "Patric Cary",
      img: "images/testimonial/client-sm-2.jpg",
      exp: "Lorem ipsum",
      summary:
        " “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae suscipit tellus mauris a diam maecenas sed enim ut sem viverra.”",
    },
    {
      name: "Dennis Jacques",
      img: "images/testimonial/client-sm-3.jpg",
      exp: "Lorem ipsum",
      summary:
        " “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae suscipit tellus mauris a diam maecenas sed enim ut sem viverra.”",
    },
    {
      name: "Chris Tom",
      img: "images/testimonial/client-sm-4.jpg",
      exp: "Lorem ipsum",
      summary:
        " “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae suscipit tellus mauris a diam maecenas sed enim ut sem viverra.”",
    },
  ],
  posters: [
    {
      id: 1,
      img: "images/clients/client-logo2.png",
    },
    {
      id: 2,
      img: "images/clients/client-logo3.png",
    },
    {
      id: 3,
      img: "images/clients/client-logo1.png",
    },
    {
      id: 4,
      img: "images/clients/client-logo2.png",
    },
    {
      id: 5,
      img: "images/clients/client-logo3.png",
    },
    {
      id: 6,
      img: "images/clients/client-logo1.png",
    },
    {
      id: 7,
      img: "images/clients/client-logo3.png",
    },
    {
      id: 8,
      img: "images/clients/client-logo1.png",
    },
    {
      id: 9,
      img: "images/clients/client-logo2.png",
    },
    {
      id: 10,
      img: "images/clients/client-logo3.png",
    },
    {
      id: 11,
      img: "images/clients/client-logo1.png",
    },
    {
      id: 12,
      img: "images/clients/client-logo2.png",
    },
  ],
};

export const ContactDetails = [
  {
    icon: "fas fa-map-marker-alt",
    title: "Visit Us",
    p1: "Adrx line 1",
    p2: "Adrx line 2",
  },
  {
    icon: "fas fa-phone-alt",
    title: "Call Us Now",
    p1: "Phone: (+060) 9898980098",
    p2: " Fax: (+060) 8898880088",
  },
  {
    icon: "fas fa-envelope",
    title: "Inquiries",
    p1: "example@example.com",
    p2: " Mon to Fri (10 am – 8 pm)",
  },
];

export const socialIcons = [
  {
    title: "Twitter",
    icon: "fab fa-twitter",
    href: "",
    className: "social-icons-twitter",
  },
  {
    title: "Facebook",
    icon: "fab fa-facebook-f",
    href: "",
    className: "social-icons-facebook",
  },
  {
    title: "Linkedin",
    icon: "fab fa-linkedin-in",
    href: "",
    className: "social-icons-linkedin",
  },
];